/** @format */

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import AddUpdatePaymentDetails from "./AddUpdatePaymentDetails";
import AddUpdateShipment from "./AddUpdateShipment";
import ShipmentDialog from "./ShipmentDialog";

function ViewShipmentDetails() {
  const [shipmentDetails, setShipmentDetails] = useState(null);
  const [draftMode, setdraftMode] = useState(false);
  const [paymentMode, setPaymentMode] = useState(false);
  const [ShipmentEditMode, setShipmentEditMode] = useState(false);
  const [paymentEditMode, setPaymentEditMode] = useState(false);
  const { shipmentId } = useParams();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  async function getShippingDetails() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/shipment/${shipmentId}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(response.data);
      setShipmentDetails(response.data);
    } catch (err) {
      console.log(err);
    }
  }

  let shippingPaymentDetails = {
    invoiceValue: shipmentDetails?.shipmentDet?.invoiceVal,
    invoiceCurrency : shipmentDetails?.shipmentDet?.currency
  };

  switch (shipmentDetails?.shipmentDet?.paymentTerm) {
    case "TT":
      shippingPaymentDetails["balDue"] = shipmentDetails?.ttPayment?.balDue;
      shippingPaymentDetails["balDueDt"] = shipmentDetails?.ttPayment?.balDueDt;
      break;

    case "LC":
      shippingPaymentDetails["balDue"] = shipmentDetails?.lcPayment?.balDue;
      shippingPaymentDetails["balDueDt"] = shipmentDetails?.lcPayment?.balDueDt;
      break;

    case "DA_DP":
      shippingPaymentDetails["balDue"] = shipmentDetails?.dadpPayment?.balDue;
      shippingPaymentDetails["balDueDt"] =
        shipmentDetails?.dadpPayment?.balDueDt;
      break;

    default:
      break;
  }

  useEffect(() => {
    getShippingDetails();
  }, [shipmentId]);

  if (shipmentDetails?.shipmentDet?.status === "PENDING_PAYMENT_DET") {
    return (
      <>
        <ShipmentDialog
          openDialog={open}
          closeDialog={handleClose}
          dialogTitle={`${shipmentDetails?.shippingId} : ${shipmentDetails?.shipmentDet?.customerName}`}
          dialogBody="Shipment Details has been submitted! Payment Details is yet to be completed"
          actionButtonLabel="View Shipment"
          handelActionButton={setShipmentEditMode}
          anotherActionButtonLabel="Continue with Payment Details"
          handelAnotherActionButton={setPaymentMode}
        />
        {ShipmentEditMode && (
          <AddUpdateShipment
            shipmentDetails={shipmentDetails}
            editMode={true}
          />
        )}
        {paymentMode && (
          <AddUpdatePaymentDetails shippingId={shipmentDetails?.shippingId} shippingPaymentDetails={shippingPaymentDetails} />
        )}
      </>
    );
  }

  if (shipmentDetails?.shipmentDet?.status === "DRAFT") {
    return (
      <>
        <ShipmentDialog
          openDialog={open}
          closeDialog={handleClose}
          dialogTitle={`${shipmentDetails?.shippingId} : ${shipmentDetails?.shipmentDet?.customerName}`}
          dialogBody="Shipment Details is in Draft! Please submit the details first, After that
          you can continue with payment details"
          actionButtonLabel="Submit Shipment Details"
          handelActionButton={setdraftMode}
        />
        {draftMode && <AddUpdateShipment shipmentDetails={shipmentDetails} />}
      </>
    );
  }

  if (shipmentDetails?.shipmentDet?.status === "SUBMITTED") {
    return (
      <>
        <ShipmentDialog
          openDialog={open}
          closeDialog={handleClose}
          dialogTitle={`${shipmentDetails?.shippingId} : ${shipmentDetails?.shipmentDet?.customerName}`}
          dialogBody="Shipment And Payment Details successfully Submitted"
          actionButtonLabel="View/Edit Shipment"
          handelActionButton={setShipmentEditMode}
          anotherActionButtonLabel="View/Edit Payment"
          handelAnotherActionButton={setPaymentEditMode}
        />
        {ShipmentEditMode && (
          <AddUpdateShipment
            shipmentDetails={shipmentDetails}
            editMode={true}
          />
        )}
        {paymentEditMode && (
          <AddUpdatePaymentDetails
            shippingId={shipmentDetails?.shippingId}
            paymentDt={shipmentDetails?.paymentDet?.paymentDt}
            paymentReceivedDt={shipmentDetails?.paymentDet?.paymentReceivedDt}
            shippingPaymentDetails={shippingPaymentDetails}
            editMode={true}
          />
        )}
      </>
    );
  }
}

export default ViewShipmentDetails;
